import {
  ButtonColorMap,
  ButtonIconGapMap,
  ButtonSizeMap,
  ButtonVariantMap,
  ButtonWidthMap,
} from '../../types/v2/button';

export const BUTTON_ICON_GAP: ButtonIconGapMap = {
  sm: 'gap-1',
  base: 'gap-2',
  lg: 'gap-4',
};

export const BUTTON_VARIANT: ButtonVariantMap = {
  outline: 'btn-outline',
  filled: '',
  text: '',
};

export const BUTTON_COLOR: ButtonColorMap = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  accent: 'btn-accent',
  success: 'btn-success',
  danger: 'btn-error',
  glass: 'btn-glass',
  'base-100': 'btn-base-100',
  'base-200': 'btn-base-100',
};

export const BUTTON_WIDTH: ButtonWidthMap = {
  fit: 'w-fit',
  full: 'btn-block',
  wide: 'btn-wide',
};

export const BUTTON_SIZE: ButtonSizeMap = {
  sm: 'btn-sm',
  md: 'btn-md',
  lg: 'btn-lg',
  base: '',
};
